import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { InfoBox } from 'components/message-boxes/information-box/InformationBox'

import './PSD2Info.scss'

export const PSD2Info = () => {
	const { t } = useTranslation()
	const { msp, dispatchMsp } = useContext(MspDispatchContext)

	const next = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index + 1,
			},
		})
	}

	return (
		<div className="psd2-info">
			<p className="psd2-info-description">{t('Psd2InfoDescription')}</p>

			<div className="psd2-info-steps">
				<div className="psd2-info-step">
					<div className="psd2-info-step-circle">1</div>
					<p>{t('Psd2InfoStep1')}</p>
				</div>
				<div className="psd2-info-step-arrow" aria-hidden="true" />
				<div className="psd2-info-step">
					<div className="psd2-info-step-circle">2</div>
					<p>{t('Psd2InfoStep2')}</p>
				</div>
				<div className="psd2-info-step-arrow" aria-hidden="true" />
				<div className="psd2-info-step">
					<div className="psd2-info-step-circle">3</div>
					<p>{t('Psd2InfoStep3')}</p>
				</div>
			</div>

			<InfoBox
				infoType="checklist"
				message={
					<ul>
						<li>{t('Psd2InfoChecklist1')}</li>
						<li>{t('Psd2InfoChecklist2')}</li>
						<li>{t('Psd2InfoChecklist3')}</li>
						<li>{t('Psd2InfoChecklist4')}</li>
					</ul>
				}
			/>

			<div className="psd2-info-next-button">
				<button
					id="psd2-info-continue-button"
					className="btn btn-primary"
					onClick={() => {
						setTimeout(() => {
							next()
						}, 400)
					}}>
					{t('Continue')}
				</button>
			</div>

			<p className="psd2-info-faq">
				<strong>{t('Psd2InfoWhatIsPsd2Title')}</strong>{' '}
				{t('Psd2InfoWhatIsPsd2Description')}
			</p>
		</div>
	)
}
